module.exports = __webpack_public_path__ + "static/media/wab32_1014.e9fe6307.ico";